/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateContactByEmailMutationRequest,
  CreateContactByEmailMutationResponse,
} from "../types/CreateContactByEmail.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createContactByEmailMutationKey = () =>
  [{ url: "/v1/client-settings/create-supplier-mapping-by-email" }] as const

export type CreateContactByEmailMutationKey = ReturnType<
  typeof createContactByEmailMutationKey
>

/**
 * @summary Create a supplier mapping by email
 * {@link /v1/client-settings/create-supplier-mapping-by-email}
 */
export async function createContactByEmail(
  data: CreateContactByEmailMutationRequest,
  config: Partial<RequestConfig<CreateContactByEmailMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateContactByEmailMutationResponse,
    ResponseErrorConfig<Error>,
    CreateContactByEmailMutationRequest
  >({
    method: "POST",
    url: `/v1/client-settings/create-supplier-mapping-by-email`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createContactByEmailMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateContactByEmailMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createContactByEmailMutationKey()
  return mutationOptions<
    ResponseConfig<CreateContactByEmailMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateContactByEmailMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createContactByEmail(data, config)
    },
  })
}

/**
 * @summary Create a supplier mapping by email
 * {@link /v1/client-settings/create-supplier-mapping-by-email}
 */
export function useCreateContactByEmail<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateContactByEmailMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateContactByEmailMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateContactByEmailMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? createContactByEmailMutationKey()

  const baseOptions = createContactByEmailMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateContactByEmailMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateContactByEmailMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateContactByEmailMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateContactByEmailMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateContactByEmailMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateContactByEmailMutationRequest },
    TContext
  >
}
